module.exports = __webpack_public_path__ + "static/media/logo.b9894374.png";